import { render, staticRenderFns } from "./Certification.vue?vue&type=template&id=07c94dc1&scoped=true"
import script from "./Certification.vue?vue&type=script&lang=js"
export * from "./Certification.vue?vue&type=script&lang=js"
import style0 from "./Certification.vue?vue&type=style&index=0&id=07c94dc1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c94dc1",
  null
  
)

export default component.exports